module.exports = __webpack_public_path__ + "static/paczki-81402f17002d4d7f7d87b436d7061f13.png";